export default {
  en: {
    description: 'Generate integration credentials',
    name: 'Name of integration',
    alertBot: 'All public integrations are limited to anti-bot protections, except backend',
    integrationType: 'Integration type',
    ipWhitelist: 'IP Whitelist',
    privilegeAlert: 'The selected privilege will have same access as a user with that privilege, be careful what privilege you select',
    messages: {
      success: 'The API Key was {action} successfully'
    },
    singleViewApiKey: 'Copy the API Token',
    copyOrLost: 'Make sure to copy the token now, you won\'t be able to see it again!',
    hidden: 'Regenerate to get a new token',
  },
  es: {
    description: 'Genere credenciales de integración',
    name: 'Nombre de la integración',
    alertBot: 'Todas las integraciones públicas están limitadas a protecciones anti-bot, excepto backend',
    integrationType: 'Tipo de integración',
    ipWhitelist: 'Lista blanca de IPs',
    privilegeAlert: 'El privilegio seleccionado tendrá el mismo acceso que un usuario con ese privilegio, tenga cuidado con el privilegio que selecciona',
    messages: {
      success: 'La API Key se ha {action} correctamente'
    },
    singleViewApiKey: 'Copie el token de API',
    copyOrLost: '¡Asegúrese de copiar el token ahora, no podrá verlo de nuevo!',
    hidden: 'Regenerar para obtener un nuevo token',
  },
  fr: {
    description: 'Générez des informations d\'identification pour l\'intégration',
    name: 'Nom de l\'intégration',
    alertBot: 'Toutes les intégrations publiques sont soumises à des protections anti-bots, sauf le backend',
    integrationType: 'Type d\'intégration',
    ipWhitelist: 'Liste blanche des IP',
    privilegeAlert: 'Le privilège sélectionné aura le même accès qu\'un utilisateur avec ce privilège, faites attention au privilège que vous sélectionnez',
    messages: {
      success: 'La clé API a été {action} correctement'
    },
    singleViewApiKey: 'Copiez le jeton API',
    copyOrLost: 'Assurez-vous de copier le jeton maintenant, vous ne pourrez plus le voir !',
    hidden: 'Régénérez pour obtenir un nouveau jeton',
  }
}
